module.exports = __webpack_public_path__ + "static/media/texture.72aa7662.svg";